import { useAuth } from 'hooks';

import { useCommonData, useDetectActivity } from '../hooks';

export const Processes = () => {
  useAuth();

  useCommonData();

  useDetectActivity();

  return null;
};
